/**
 * The seven-phase delivery lifecycle — PRODUCT taxonomy.
 *
 * Re-homed out of `src/demo/data.ts` by PX-W6.6 (TASK-188E6E40, spec §6.3):
 * the phase ladder is what every engagement screen is cut by and what the
 * backend's phase gates are keyed on, so it is not demo seed. `src/demo/data.ts`
 * re-exports these symbols, which is why the ~40 authored demo-content modules
 * needed no edit; product code imports THIS module (invariant I-2).
 *
 * ⚠ Two lifecycles coexist and neither is renamed into the other: `PHASES`
 * (delivery — the 7 tiles on every project screen) and `ENGAGEMENT_PHASES`
 * (Rev A, `@/modules/architecture`), joined by `engagementPhaseFor`.
 */

export type PhaseKey =
  | 'discover'
  | 'design'
  | 'build'
  | 'migrate'
  | 'test'
  | 'go-live'
  | 'maintain'

export interface Phase {
  key: PhaseKey
  name: string
  subLabel: string
  gate: 'Client sign-off' | 'Internal' | 'Quarterly'
}

export const PHASES: readonly Phase[] = [
  { key: 'discover', name: 'Discover', subLabel: 'Scope & fit-gap', gate: 'Client sign-off' },
  { key: 'design', name: 'Design', subLabel: 'Solution blueprint', gate: 'Client sign-off' },
  { key: 'build', name: 'Build', subLabel: 'Modules & config', gate: 'Internal' },
  { key: 'migrate', name: 'Migrate', subLabel: 'Data mapping', gate: 'Internal' },
  { key: 'test', name: 'Test', subLabel: 'QA & UAT', gate: 'Client sign-off' },
  { key: 'go-live', name: 'Go-Live', subLabel: 'Train & cutover', gate: 'Client sign-off' },
  { key: 'maintain', name: 'Maintain', subLabel: 'AMS & upgrades', gate: 'Quarterly' },
] as const

/** Position of a phase in the ladder; `-1` when the key is unknown. */
export const phaseIndex = (key: PhaseKey): number => PHASES.findIndex((p) => p.key === key)
